import { Component, Input } from '@angular/core';
import { AssessmentSubType, ReportDetailItem } from '../../../../services/model';
import { DatePipe, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-report-detail-row',
  standalone: true,
  imports: [DatePipe, JsonPipe],
  templateUrl: './report-detail-row.component.html',
  styleUrl: './report-detail-row.component.scss',
})
export class ReportDetailRowComponent {
  @Input() item!: ReportDetailItem;

  assessmentSubTypeLabels: { [key in AssessmentSubType]: string } = {
    custom: 'CUSTOM',
    bbt: 'BBT',
    bbs: 'BBS',
    ts: 'TS',
    tug: 'TUG',
    fga: 'FGA',
    fr: 'FR',
    mwt6: 'MWT6',
    nhpt: 'NHPT',
    grasp: 'ARAT: Greifen (grasp)',
    grip: 'ARAT: Griff (grip)',
    pinch: 'ARAT: Präzisionsgriff (pinch)',
    gross: 'ARAT: Grobe Bewegung (gross movement)',
  };
}
